<router-outlet />
<app-pwa-install />
<app-pwa-update />
<app-global-spinner />
<app-toast-container />
<app-dialog-host />
